import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  overrides: {
    MuiSelect: {
      select: {
        '&:focus': {
          backgroundColor: 'inherit',
        },
      },
    },
    MuiInputLabel: {
      root: {
        fontSize: 12,
      },
      shrink: {
        '&.MuiInputLabel-shrink': {
          transform: 'translate(14px, -6px) scale(0.9)',
          transformOrigin: 'top center',
        },
      },
    },
    MuiTypography: {
      body1: {
        fontSize: 12,
      },
    },
    MuiIconButton: {
      root: {
        '&:hover': {
          backgroundColor: 'rgba(63, 81, 181, 0.08)',
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        fontSize: 12,
        '&.Mui-disabled': {
          backgroundColor: '#ddd',
        },
        '&:hover:not(.Mui-disabled):not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
          borderColor: '#166aab',
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);
